<template>
  <div class="v-date-range">
    <v-card class="v-date-range__menu-content">
      <v-card-text class="pa-0">
        <div
          :class="{
            'v-date-range__pickers': true
          }"
        >
          <v-row>
            <v-col cols="5" class="pa-0">
              <div
                class="default-scrollbar preset-container"
                v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
              >
                <v-container>
                  <v-list>
                    <v-list-item
                      v-for="(preset, index) in presets"
                      v-model="isPresetActive[index]"
                      :key="index"
                      @click.stop="selectPreset(index)"
                    >
                      <v-list-item-content>{{ preset.label }}</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-container>
              </div>
            </v-col>
            <v-col cols="7" class="px-2 py-4" color="white">
              <v-row class="date-range-row">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="190px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatDate(range[0])"
                      :label="lang.historic.filters.date_range.start"
                      prepend-icon="mdi-calendar-arrow-left"
                      readonly
                      filled
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="range[0]"
                    :max="range[1]"
                    locale="pt-br"
                    no-title
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-row>
              <v-row class="dateRangeRow">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="190px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatDate(range[1])"
                      :label="lang.historic.filters.date_range.end"
                      prepend-icon="mdi-calendar-arrow-right"
                      readonly
                      filled
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="range[1]"
                    :min="range[0]"
                    locale="pt-br"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { DEFAULT_DATE } from './constants'

import defaults from '@/modules/default'
const lang = defaults.language

export default {
  name: 'v-daterange',
  props: {
    value: {
      type: Array,
      default: () => {
        return [ DEFAULT_DATE, DEFAULT_DATE ]
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    presets: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      lang,
      menu: false,
      menu2: false,
      presetsNav: null,
      range: [ ...this.value ]
    }
  },
  computed: {
    isPresetActive () {
      return this.presets.map(
        preset =>
          preset.range[0] === this.range[0] &&
          preset.range[1] === this.range[1]
      )
    }
  },
  watch: {
    range: {
      deep: true,
      handler (newVal) {
        if (newVal[0] !== this.value[0] || newVal[1] !== this.value[1]) this.$emit('input', this.range)
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (newVal[0] !== this.range[0] || newVal[1] !== this.range[1]) this.range = [ ...this.value ]
      }
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    selectPreset (index) {
      this.range = this.presets[index].range
    }
  }
}
</script>

<style lang="scss">
.v-date-range {
  #app & {
    .v-date-range__menu-content {
      box-shadow: none !important;
      border-radius: 7px !important;
      overflow: hidden;
      .preset-container {
        height: 100vh;
        max-height: 190px;
        padding: 0px;
        .vb-content {
          padding: 0px !important;
        }
        .vb-dragger {
          margin-top: 0px !important;
        }
      }
      .date-range-row {
        max-height: 79px;
        overflow: hidden;
      }
    }
  }
  #app.theme--light & {
    .v-date-range__menu-content {
      background: #fff !important;
    }
  }
  #app.theme--dark & {
    .v-date-range__menu-content {
      background: #121212 !important;
    }
  }
}
</style>
